import { render, staticRenderFns } from "./ExerciseSchedule.vue?vue&type=template&id=be39d9e0&scoped=true"
import script from "./ExerciseSchedule.vue?vue&type=script&lang=js"
export * from "./ExerciseSchedule.vue?vue&type=script&lang=js"
import style0 from "./ExerciseSchedule.vue?vue&type=style&index=0&id=be39d9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be39d9e0",
  null
  
)

export default component.exports